import React, { useContext, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import AppContext from 'context/Context';
import classNames from 'classnames';
import NavbarTop from 'components/navbar/top/NavbarTop';
import NavbarVertical from 'components/navbar/vertical/NavbarVertical';
import Footer from 'components/footer/Footer';
import { useSelector } from 'react-redux';
import c from 'util/const';
import { callIntercom } from 'helpers/intercom-helper';
import segmentHelper from 'helpers/segment-helper';
import { setNavigateFunction } from 'util/navigation';

const MainLayout = () => {
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes('kanban');
  const isNotaryGpt = pathname === '/knowledge-center/notarygpt';
  // const isChat = pathname.includes('chat');
  const navigate = useNavigate();

  // Set the navigate function for use in modals
  useEffect(() => {
    setNavigateFunction(navigate);
  }, [navigate]);

  const { isAuthenticated } = useSelector(state => state.authentication);
  const { stage, userMaster } = useSelector(state => state.app);

  const {
    config: { isFluid, navbarPosition }
  } = useContext(AppContext);

  const { appLoadError } = useSelector(state => state.app);

  useEffect(() => {
    if (!isAuthenticated && stage === c.stages.LOGOUT) {
      segmentHelper.reset();
      callIntercom('shutdown');
      navigate('login');
    }

    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    callIntercom('update');
    if (!isAuthenticated && stage === c.stages.LOGOUT) {
      segmentHelper.reset();
      callIntercom('shutdown');
      navigate('login');
    }
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    document.documentElement.classList.toggle(
      'dashboard-notarygpt-active',
      isNotaryGpt
    );
    document.body.classList.toggle('dashboard-notarygpt-active', isNotaryGpt);

    return () => {
      document.documentElement.classList.remove('dashboard-notarygpt-active');
      document.body.classList.remove('dashboard-notarygpt-active');
    };
  }, [isNotaryGpt]);

  return (
    <div
      className={classNames(
        isFluid || isNotaryGpt ? 'container-fluid' : 'container',
        {
          'container-notarygpt': isNotaryGpt
        }
      )}
    >
      {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
        <NavbarVertical />
      )}
      <div
        className={classNames('content', {
          'pb-0': isKanban || isNotaryGpt,
          'content-notarygpt': isNotaryGpt
        })}
      >
        <NavbarTop />
        {/*------ Main Routes ------*/}
        <Outlet />
        {!isKanban && !isNotaryGpt && <Footer />}
      </div>
    </div>
  );
};

export default MainLayout;
